import { render, staticRenderFns } from "./CorporativeInfo.vue?vue&type=template&id=05e98f93&scoped=true&"
import script from "./CorporativeInfo.vue?vue&type=script&lang=js&"
export * from "./CorporativeInfo.vue?vue&type=script&lang=js&"
import style0 from "./CorporativeInfo.vue?vue&type=style&index=0&id=05e98f93&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05e98f93",
  null
  
)

export default component.exports